import FluidHeader from './FluidHeader'
import MobileMenu from './MobileMenu'
import LazyLoad from 'vanilla-lazyload'
import Flip from './Button'
import Video from './Video'
import initSlider from './Slider'

$(document).ready(() => {
  const myLazyLoad = new LazyLoad()
  MobileMenu()
  FluidHeader()
  Flip()
  Video()
  initSlider()
})
